import {clientI18n} from '../../ClientI18n.ts'
import {createDivIn, createFormIn, createInputIn, createSpanIn, createTextareaIn, setElementOnClick} from '../../ui_utils/DomUtils.ts'
import {ViewPopup} from '../ViewPopup.ts'
import {NO_OF_STARS, type UIFeedbackFormPopupController} from './UIFeedbackFormPopupController.ts'
import {ViewPopupFeedbackForm} from './ViewPopupFeedbackForm.ts'
import {ClientUserState} from '../../ClientUserState.ts'

export class ViewPopupFeedbackFormText extends ViewPopup {
    private static readonly MAX_TEXT_LENGTH = 300
    private readonly feedbackFormController: UIFeedbackFormPopupController
    private rating: number

    private formContainer: HTMLFormElement

    constructor(feedbackFormController: UIFeedbackFormPopupController) {
        super({key: 'strings:popups.feedbackForm.improve'},
            {key: 'strings:colonistCommon.utils.emptyString'},
            () => undefined,
            () => undefined,
            true)
        this.feedbackFormController = feedbackFormController
    }

    show(): void {
        super.show()
        this.rating = this.feedbackFormController.getRating() ?? 0

        this.removeXButton()
        this.changeCheckButtonText({key: 'strings:popups.feedbackForm.submit'})

        this.header.classList.add('popup-feedback-form-body')
        this.formContainer = createFormIn(this.body, 'popup-feedback-form-body')

        this.createSmallStars()
        this.createTextarea()
        this.createEmailField()

        this.formContainer.onsubmit = (e) => {
            e.preventDefault()
            this.feedbackFormController.setFormData({...this.feedbackFormController.formData, skipped: false})
            this.feedbackFormController.nextStep()
        }
    }

    private createTextarea(): void {
        const textarea = createTextareaIn(this.formContainer, 'popup-feedback-form-textarea')
        textarea.placeholder = clientI18n.t('strings:popups.feedbackForm.examplePlaceholder')
        textarea.maxLength = ViewPopupFeedbackFormText.MAX_TEXT_LENGTH

        const characterCount = createSpanIn(this.formContainer, 'popup-feedback-form-textarea-character-count', {key: 'strings:colonistCommon.utils.#buffer', options: {value: '0/300', interpolation: {escapeValue: false}}})

        textarea.addEventListener('input', (e) => {
            const target = e.target as HTMLTextAreaElement
            this.updateCharacterCount(target.value || '', characterCount)
        })

        this.setFocusStyles(textarea, true)
    }

    private updateCharacterCount(textareaText: string, characterCount: HTMLSpanElement): void {
        characterCount.innerText = `${textareaText.length}/${ViewPopupFeedbackFormText.MAX_TEXT_LENGTH}`
        this.feedbackFormController.setFormData({...this.feedbackFormController.formData, feedback: textareaText})
    }

    private createEmailField() {
        if(ClientUserState.userState?.isLoggedIn) return

        const emailField = createDivIn(this.formContainer, 'popup-feedback-form-email-field')

        const emailLabel = createSpanIn(emailField, 'popup-feedback-form-email-label', {key: 'strings:popups.feedbackForm.optionalEmail'})

        const emailInput = createInputIn(emailField, 'popup-feedback-form-input ')
        emailInput.placeholder = 'colonistplayer@gmail.com'
        emailInput.type = 'email'

        emailInput.addEventListener('input', (e) => {
            const target = e.target as HTMLTextAreaElement
            const emailText = target.value || ''
            this.feedbackFormController.setFormData({...this.feedbackFormController.formData, email: emailText})
        })

        this.setFocusStyles(emailInput, true)
    }

    private createSmallStars(): void {
        const starsContainer = createDivIn(this.header, 'popup-feedback-form-stars-container')
        const stars = Array.from({length: NO_OF_STARS}, () => ViewPopupFeedbackForm.createStar(starsContainer, true, true))

        this.setStarsColorBasedOnRating(stars)
        this.addStarsClickListeners(stars)
    }

    private setStarsColorBasedOnRating(stars: HTMLImageElement[]): void {
        stars.slice(0, this.rating).forEach((star) => star.style.filter = 'saturate(1)')
        stars.slice(this.rating).forEach((star) => star.style.filter = 'saturate(0.1)')
    }

    private addStarsClickListeners(stars: HTMLImageElement[]): void {
        for(const [index, star] of stars.entries()) {
            setElementOnClick(star, () => {
                this.feedbackFormController.setFormData({...this.feedbackFormController.formData, rate: index + 1})
                this.rating = index + 1
                this.setStarsColorBasedOnRating(stars)
            })
        }
    }
}
